import { useEffect, useCallback } from "react";
import { useSession, signOut } from "next-auth/react";
import { useRouter } from "next/router";
import axios from "axios";
import nookies from "nookies";

const PUBLIC_PATHS = ["/", "/sign-in", "/sign-up", "/contact-us", "/logout"];

function AuthGuard() {
  const { data: session, status } = useSession();
  const router = useRouter();

  const handleSignOut = useCallback(async () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
      nookies.destroy(null, "next-auth.session-token");
      nookies.destroy(null, "__Secure-next-auth.session-token");
    } catch (_) {
      console.log("_");
    }
    await signOut({ redirect: false });
    router.push("/");
  }, [router]);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        const responseStatus = error?.response?.status;
        if (responseStatus === 401) {
          const isPublic = PUBLIC_PATHS.some((p) =>
            router.pathname.startsWith(p)
          );
          if (!isPublic) {
            await handleSignOut();
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [handleSignOut, router.pathname]);

  useEffect(() => {
    if (status === "loading") return;

    const sessionAny = session as any;
    const hasTokenError =
      sessionAny?.error === "RefreshAccessTokenError" ||
      sessionAny?.error === "TokenExpiredError" ||
      sessionAny?.error === "InvalidToken";

    if (hasTokenError) {
      handleSignOut();
      return;
    }

    if (status === "unauthenticated") {
      const isPublic = PUBLIC_PATHS.some(
        (p) =>
          router.pathname === p ||
          router.pathname.startsWith("/sign-") ||
          router.pathname.startsWith("/subscription") ||
          router.pathname.startsWith("/admin-portal/onboarding")
      );
      if (!isPublic) {
        //
      }
    }
  }, [session, status, router.pathname, handleSignOut]);

  return null;
}

export default AuthGuard;
